import classNames from 'classnames';

export default function Button({ children, className, ...props }) {
  return (
    <button className={classNames('pure-button', className)} {...props}>
      {children}
    </button>
  );
}
